import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import * as $ from 'jquery';
declare function ire(string,{}): any;
@Component({
  selector: 'app-publication-check',
  templateUrl: './publication-check.component.html',
  styleUrls: ['./publication-check.component.scss']
})
export class PublicationCheckComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('출판 가능성을 높여주는 트링카 출판 준비 체크');
    this.metaTagService.updateTag({ name: 'description', content: '저널 선정에서 윤리기준 준수까지 20가지 이상의 체크포인트로 문서를 평가하여 출판 가능성을 높여 드립니다.' });
    this.metaTagService.updateTag({ property: 'og:title', content: '출판 가능성을 높여주는 트링카 출판 준비 체크' });
    this.metaTagService.updateTag({ property: 'og:description', content: '저널 선정에서 윤리기준 준수까지 20가지 이상의 체크포인트로 문서를 평가하여 출판 가능성을 높여 드립니다.' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/features/publication-readiness-checks' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/features/publication-readiness-checks' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/technical-checks' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/technical-checks' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/publication-readiness-checks' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/publication-readiness-checks' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/publication-readiness-checks' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/publication-readiness-checks' }); 
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/publication-readiness-checks' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/publication-readiness-checks' });
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../assets/js/wisepop.js', function () { });
    }
    
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $('#closedPopup, #wordPluginPopup').click(function () {
        $('iframe.youtubeVideoForTryDemo').remove()
      });

      $('#VewiVideoSection').click(function () {
        if (!$('#iframe').length) {
          $('#iframeHolder').html('<iframe class="youtubeVideoForTryDemo" id="iframe" src="https://www.youtube.com/embed/c8yyiW2tEjE" width="100%" height="450"></iframe>');
        }
      });

    }
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
